import { rtkapi } from './rtkapi';

const videotutorialapi = rtkapi.enhanceEndpoints({addTagTypes: ['videoTutorial']}).injectEndpoints({
    endpoints: (build) => ({
        getVideoTutorials: build.query({
            query: (params) => ({ url: '/video-tutorials/', params }),
         providesTags: ['videoTutorial']
        }),
        finishVideo: build.mutation({
            query: (data) => ({ url: '/finish-video/', data, method: "POST"}),
            invalidatesTags: ['videoTutorial']
        }), 
        UpdateVideoProgress: build.mutation({
            query: (data) => ({ url: '/update-video-progress/', data, method: "POST"}),
            invalidatesTags: ['videoTutorial']
        }), 
    })
});

export const { useGetVideoTutorialsQuery, useFinishVideoMutation, useUpdateVideoProgressMutation } = videotutorialapi;